   // custom-lightbox.js

   document.addEventListener('DOMContentLoaded', function() {
    // Initialize product quickview functionality
    initProductQuickview();
    
    // Initialize page view functionality
    initPageView();
  });

  /**
   * Initialize product quickview functionality
   */
  function initProductQuickview() {
    // Get all quickview buttons (both old and new class names)
    const quickViewButtons = document.querySelectorAll('.quick-product__btn, .alrighty--slider-product-card__quickview');
    const quickviewLightbox = document.getElementById('quickview-lightbox');
    
    if (!quickViewButtons.length || !quickviewLightbox) return;
    
    const lightboxContent = document.getElementById('lightbox-content');
    const closeBtn = quickviewLightbox.querySelector('.close');
    
    if (!lightboxContent || !closeBtn) return;
    
    // Add click event to each quick view button
    quickViewButtons.forEach(button => {
      if (!button.hasAttribute('data-has-listener')) {
        button.setAttribute('data-has-listener', 'true');
        
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const productId = this.getAttribute('data-product-id');
          const productHandle = this.getAttribute('data-product-handle');
          
          if (!productHandle) {
            console.error('No product handle found for quick view');
            return;
          }
          
          // Show loading state
          lightboxContent.innerHTML = '<p class="loading-message">Loading product details...</p>';
          
          // Show the lightbox
          openLightbox(quickviewLightbox);
          
          // Fetch the product content
          const url = window.location.origin + '/products/' + productHandle + '?view=modal';
          
          fetch(url)
            .then(response => response.text())
            .then(html => {
              // Create a temporary container to parse the HTML
              const tempContainer = document.createElement('div');
              tempContainer.innerHTML = html;
              
              // Extract the product section
              const productSection = tempContainer.querySelector('.product-section');
              
              if (productSection) {
                // Inject the product section into the lightbox
                lightboxContent.innerHTML = '';
                lightboxContent.appendChild(productSection);
                
                // Find the blocks holder and load its content
                const blocksHolder = productSection.querySelector('[data-blocks-holder]');
                if (blocksHolder) {
                  const blocksUrl = blocksHolder.dataset.url;
                  if (blocksUrl) {
                    fetch(blocksUrl)
                      .then(response => response.text())
                      .then(blocksHtml => {
                        const blocksParser = new DOMParser();
                        const blocksDoc = blocksParser.parseFromString(blocksHtml, 'text/html');
                        const blocks = blocksDoc.querySelector('[data-product-blocks]');
                        
                        if (blocks) {
                          blocksHolder.innerHTML = '';
                          blocksHolder.appendChild(blocks);
                          blocksHolder.classList.add('product-form-holder--loaded');
                          
                          // Check if theme.js is loaded
                          if (typeof theme === 'undefined') {
                            console.warn('theme.js not loaded, attempting to load it...');
                            // Load theme.js if not already loaded
                            const script = document.createElement('script');
                            script.src = '/assets/theme.js';
                            script.onload = function() {
                              initializeProductSection();
                            };
                            document.head.appendChild(script);
                          } else {
                            initializeProductSection();
                          }
                        }
                      });
                  }
                }
                
                function initializeProductSection() {
                  // Re-initialize any scripts that might be needed
                  if (typeof theme !== 'undefined' && theme.sections) {
                    theme.sections.register('product', theme.Product, lightboxContent);
                    
                    // Find the product form and handle submission
                    const productForm = lightboxContent.querySelector('form[action="/cart/add"]');
                    if (productForm) {
                      productForm.addEventListener('submit', function(e) {
                        e.preventDefault();
                        
                        // Get the selected variant
                        const variantInput = productForm.querySelector('input[name="id"]');
                        if (!variantInput) return;
                        
                        // Add to cart using the cart drawer
                        const formData = new FormData(productForm);
                        fetch('/cart/add.js', {
                          method: 'POST',
                          body: formData
                        })
                        .then(response => response.json())
                        .then(item => {
                          // Trigger cart drawer update
                          document.dispatchEvent(new CustomEvent('cart:build'));
                          
                          // Close the quick view modal
                          closeLightbox(quickviewLightbox);
                        })
                        .catch(error => {
                          console.error('Error adding to cart:', error);
                        });
                      });
                    }
                    
                    // Listen for variant changes
                    lightboxContent.addEventListener('variant:change', function(evt) {
                      const variant = evt.detail.variant;
                      if (variant) {
                        const variantInput = lightboxContent.querySelector('input[name="id"]');
                        if (variantInput) {
                          variantInput.value = variant.id;
                        }
                      }
                    });
                  }
                  
                  // Initialize collapsible elements if they exist
                  if (typeof theme !== 'undefined' && theme.collapsibles) {
                    theme.collapsibles.init();
                  }
                  
                  // Initialize video modal if it exists
                  if (typeof theme !== 'undefined' && theme.videoModal) {
                    theme.videoModal();
                  }
                }
              } else {
                lightboxContent.innerHTML = '<p class="error-message">Could not load product content. Please try again later.</p>';
              }
            })
            .catch(error => {
              console.error('Error fetching product content:', error);
              lightboxContent.innerHTML = '<p class="error-message">Error loading product content. Please try again later.</p>';
            });
        });
      }
    });
    
    // Close button click handler
    closeBtn.addEventListener('click', function() {
      closeLightbox(quickviewLightbox);
    });
  }

  /**
   * Initialize page view functionality
   */
  function initPageView() {
    const pageExpandButtons = document.querySelectorAll('.featured-content__card-plus-button');
    const pageCards = document.querySelectorAll('.featured-content__card[data-page-url]');
    const pageviewLightbox = document.getElementById('pageview-lightbox');
    
    if ((!pageExpandButtons.length && !pageCards.length) || !pageviewLightbox) return;
    
    const lightboxContent = pageviewLightbox.querySelector('.lightbox-content .modal-body');
    const closeBtn = pageviewLightbox.querySelector('.close');
    
    if (!lightboxContent || !closeBtn) return;

    // Function to handle opening the lightbox
    const openPageLightbox = (pageUrl) => {
      if (!pageUrl) return;
      
      // Show loading state
      lightboxContent.innerHTML = '<p class="loading-message">Loading content...</p>';
      
      // Show the lightbox
      openLightbox(pageviewLightbox);
      
      // Fetch the page content
      fetchPageContent(pageUrl, lightboxContent);
    };
    
    // Add click event to each page expand button (only for buttons with data-page-url, not links)
    pageExpandButtons.forEach(button => {
      // Only handle buttons that have data-page-url (lightbox mode), not links
      if (button.hasAttribute('data-page-url')) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const pageUrl = this.getAttribute('data-page-url');
          openPageLightbox(pageUrl);
        });
      }
    });

    // Add click event to each card
    pageCards.forEach(card => {
      card.addEventListener('click', function(e) {
        // Don't trigger if clicking on a link or the plus button
        if (e.target.closest('a') || e.target.closest('.featured-content__card-plus-button')) {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        const pageUrl = this.getAttribute('data-page-url');
        openPageLightbox(pageUrl);
      });
    });
    
    // Close button click handler
    closeBtn.addEventListener('click', function() {
      closeLightbox(pageviewLightbox);
    });
    
    // Close when clicking outside content
    pageviewLightbox.addEventListener('click', function(event) {
      if (event.target === pageviewLightbox) {
        closeLightbox(pageviewLightbox);
      }
    });
    
    // Escape key handler
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && pageviewLightbox.style.display === 'flex') {
        closeLightbox(pageviewLightbox);
      }
    });
  }

  /**
   * Fetch page content using AJAX and inject it into the lightbox
   * @param {string} url - The URL to fetch
   * @param {HTMLElement} container - The container to inject the content into
   */
  function fetchPageContent(url, container) {
    if (!url || !container) return;
    
    // Add a timestamp to prevent caching
    const fetchUrl = url + (url.includes('?') ? '&' : '?') + '_t=' + new Date().getTime();
    
    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        // Create a temporary container to parse the HTML
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = html;
        
        // Extract the main content (adjust selector as needed)
        const mainContent = tempContainer.querySelector('main') || 
                            tempContainer.querySelector('.main-content') || 
                            tempContainer.querySelector('#MainContent') ||
                            tempContainer.querySelector('article') ||
                            tempContainer.querySelector('.page-width');
        
        if (mainContent) {
          // Inject the main content into the lightbox
          container.innerHTML = mainContent.innerHTML;
          
          // Initialize slider after content is loaded
          const lightbox = container.closest('.lightbox');
          if (lightbox) {
            initializeSliderInLightbox(lightbox);
          }
        } else {
          // If we can't find the main content, show an error
          container.innerHTML = '<p class="error-message">Could not load content. Please try again later.</p>';
        }
      })
      .catch(error => {
        console.error('Error fetching page content:', error);
        container.innerHTML = '<p class="error-message">Error loading content. Please try again later.</p>';
      });
  }

  /**
   * Re-initialize scripts in the injected content
   * @param {HTMLElement} container - The container with the injected content
   */
  function reinitializeScripts(container) {
    // Find all script tags in the injected content
    const scripts = container.querySelectorAll('script');
    
    // Execute each script
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      
      // Copy attributes
      Array.from(script.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      
      // Copy content
      newScript.textContent = script.textContent;
      
      // Replace the old script with the new one
      script.parentNode.replaceChild(newScript, script);
    });

    // Re-initialize any event listeners or functionality
    if (typeof initProductQuickview === 'function') {
      initProductQuickview();
    }
    if (typeof initPageView === 'function') {
      initPageView();
    }
    
    // Re-initialize any Swiper instances
    if (typeof Swiper !== 'undefined') {
      // Initialize main carousel if it exists
      const mainCarousel = container.querySelector('.main-carousel');
      if (mainCarousel && !mainCarousel.swiper) {
        // Destroy existing instance if it exists
        if (mainCarousel.swiper) {
          mainCarousel.swiper.destroy(true, true);
        }
        
        // Create new instance
        new Swiper(mainCarousel, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: mainCarousel.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: mainCarousel.querySelector('.swiper-button-next'),
            prevEl: mainCarousel.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            }
          },
          on: {
            init: function() {
              console.log('Swiper initialized in lightbox');
            }
          }
        });
      }

      // Initialize other Swiper instances
      const swipers = container.querySelectorAll('.swiper:not(.main-carousel)');
      swipers.forEach(swiperElement => {
        if (!swiperElement.swiper) {
          // Destroy existing instance if it exists
          if (swiperElement.swiper) {
            swiperElement.swiper.destroy(true, true);
          }
          
          new Swiper(swiperElement, {
            slidesPerView: 4,
            spaceBetween: 20,
            loop: false,
            watchOverflow: true,
            navigation: {
              nextEl: swiperElement.querySelector('.swiper-button-next'),
              prevEl: swiperElement.querySelector('.swiper-button-prev')
            }
          });
        }
      });
    }
  }

  /**
   * Open a lightbox
   * @param {HTMLElement} lightbox - The lightbox element to open
   */
  function openLightbox(lightbox) {
    if (!lightbox) return;
    
    lightbox.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Remove background when opening lightbox
    document.body.style.background = 'none';
    const existingOverlay = document.querySelector('#MainContent')?.previousElementSibling;
    if (existingOverlay && existingOverlay.style.position === 'fixed') {
      existingOverlay.remove();
    }

    // Reinitialize slider after a short delay to ensure content is rendered
    setTimeout(() => {
      initializeSliderInLightbox(lightbox);
    }, 100);
  }

  /**
   * Initialize slider specifically in the lightbox context
   * @param {HTMLElement} lightbox - The lightbox element
   */
  function initializeSliderInLightbox(lightbox) {
    const mainCarousel = lightbox.querySelector('.main-carousel');
    if (!mainCarousel) return;

    // Destroy existing instance if it exists
    if (mainCarousel.swiper) {
      mainCarousel.swiper.destroy(true, true);
    }

    // Create new instance with the same configuration as the original
    new Swiper(mainCarousel, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: mainCarousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: mainCarousel.querySelector('.swiper-button-next'),
        prevEl: mainCarousel.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
      on: {
        init: function() {
          console.log('Slider initialized in lightbox');
        }
      }
    });
  }

  /**
   * Close a lightbox
   * @param {HTMLElement} lightbox - The lightbox element to close
   */
  function closeLightbox(lightbox) {
    if (!lightbox) return;
    
    lightbox.style.display = 'none';
    document.body.style.overflow = '';
    
    // Restore background when closing lightbox
    if (typeof handleCustomBackground === 'function') {
      handleCustomBackground();
    }
  }